<template>
  <div>
    <NavBar :admin="true" :items="items" />
    <v-main>
			<v-container>
        <v-row no-gutters>
          <v-col cols="12" md="12">
            <v-row no-gutters class="my-3">
              <span class="primary--text">
                <b v-translate>Type</b>
              </span>
              <v-btn-toggle class="ml-2" v-model="auricular" mandatory>
                <v-btn :value="false" class="text-overline" small>
                  <translate>Body</translate>
                </v-btn>
                <v-btn :value="true" class="text-overline" small>
                  <translate>Auricular</translate>
                </v-btn>
              </v-btn-toggle>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-card v-for="g in groups" :key="g.id" :to="{ name: 'edit-acu-group', params: {gid: g.id}}" class="ma-2">
              <v-card-title>
                <v-icon :color="g.color" class="mr-2">$vuetify.icons.acuIcon</v-icon>
                <span :class="$vuetify.breakpoint.mdAndDown ? 'text-subtitle-1' : 'text-h6'">{{g.name}}</span>
              </v-card-title>
              <v-card-actions></v-card-actions>
            </v-card>
          </v-col>
        </v-row>
			</v-container>
    </v-main>
  </div>
</template>

<script>
import NavBar from "@/components/authentication/NavBar.vue";

export default {
  name: "AcupunctureGroups",
  components: {
    NavBar
  },
  data: () => ({
    auricular: false
  }),
  computed: {
    items() {
			return [
				{
					text: this.$gettext("Dashboard"),
					disabled: false,
					link: true,
					to: "/admin/dashboard"
				},
				{
					text: this.$gettext("Acupuncture"),
					disabled: false,
					link: true,
					to: {name: 'admin-acu'}
				},
				{
					text: this.$gettext("Groups"),
					disabled: true,
					link: true
				}
			];
    },
    groups() {
			return this.$store.getters.acuClassicGroups(this.auricular);
		}
  },
  created() {
    this.$store.dispatch("GET_DATA").then(() => {});
	}
}
</script>